import { render, staticRenderFns } from "./requestBa.vue?vue&type=template&id=12925536"
import script from "./requestBa.vue?vue&type=script&lang=js"
export * from "./requestBa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports